import React from 'react';

import { WarningAmberOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

import styles from './StlHelperTxt.module.css';

type StlHelperTxtProps = {
  txt?: string;
  variant: 'error' | 'info';
  title?: string;
};

export default function StlHelperTxt({
  txt,
  variant,
  title,
}: StlHelperTxtProps) {
  return (
    <Box
      title={title || undefined}
      component="span"
      className={`${styles.box} ${variant === 'error' && styles.box_error}`}
    >
      {variant === 'error' && <WarningAmberOutlined className={styles.icon} />}
      {txt && <Typography variant="caption">{txt}</Typography>}
    </Box>
  );
}
